module.exports = __webpack_public_path__ + "static/media/03_variedades_mobile.6796ade5.jpg";